import Swiper, {Navigation, Pagination} from "swiper";

const TestimonialSlider = (elements) => {
  if (elements.length < 1) return;

  elements.forEach(container => init(container));
  
  function init(container) {
    const swiper = new Swiper(container, {
      modules: [Navigation, Pagination],
      pagination: {
        el: '.swiper-pagination',
      },
      navigation: {
        prevEl: '.section-testimonials__swiper-prev',
        nextEl: '.section-testimonials__swiper-next',
      },
      loop: true
    });
  }
}

export default TestimonialSlider;
